export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ProjectDetailsChild.vue?vue&type=template&id=aabd7a58&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ProjectDetailsChild.vue?vue&type=template&id=aabd7a58&scoped=true&
// module id = 295
// module chunks = 0